import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './diagnosis.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class DiagnosisDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      this.props.diagnosis.isNullMessageHolder === false ?
      <div className="row item-row"
        data-qa={'diagnosis_' + this.props.diagnosis.icdDescriptionFull}
      >
        <div className="col-md-4 primary-data">
          {
            this.props.diagnosis.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {this.props.diagnosis.icdDescriptionFull}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.diagnosisDate} />}
                value={this.props.diagnosis.diagnosisDate} language={this.props.language} isDate
                isActive={this.configurationActive('DiagnosisDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.laterality} />}
                value={this.props.diagnosis.laterality} language={this.props.language}
                isActive={this.configurationActive('Laterality')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.histologyCode} />}
                value={this.props.diagnosis.histologyCode} language={this.props.language}
                isActive={this.configurationActive('HistologyCode')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.histologyDescription} />}
                value={this.props.diagnosis.histologyDescription} language={this.props.language}
                isActive={this.configurationActive('HistologyDescription')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.grade} />}
                value={this.props.diagnosis.grade} language={this.props.language}
                isActive={this.configurationActive('Grade')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.stagingSystem} />}
                value={this.props.diagnosis.stagingSystem} language={this.props.language}
                isActive={this.configurationActive('StagingSystem')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.stage} />}
                value={this.props.diagnosis.stage} language={this.props.language}
                isActive={this.configurationActive('Stage')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.tStage} />}
                value={this.props.diagnosis.tStage} language={this.props.language}
                isActive={this.configurationActive('TStage')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.nStage} />}
                value={this.props.diagnosis.nStage} language={this.props.language}
                isActive={this.configurationActive('NStage')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.mStage} />}
                value={this.props.diagnosis.mStage} language={this.props.language}
                isActive={this.configurationActive('MStage')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.provider} />}
                value={this.props.diagnosis.provider} language={this.props.language}
                isActive={this.configurationActive('Provider')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.diagnosis.institution} language={this.props.language}
                isActive={this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.diagnosis.providerPhone} language={this.props.language}
                isActive={this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.diagnosis.providerEmail} language={this.props.language}
                isActive={this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.diagnosisType} />}
                value={this.props.diagnosis.diagnosisType} language={this.props.language}
                isActive={this.configurationActive('DiagnosisType')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.icdCode} />}
                value={this.props.diagnosis.icdCode} language={this.props.language}
                isActive={this.configurationActive('IcdCode')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.diagnosis.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="diagnosis_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.diagnosis.nullMessage}
        </div>
      </div>
    );
  }
}

DiagnosisDetail.propTypes = {
  diagnosis: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
